export function hasPermission(permissionKeys = [], permissionKey = "") {
  if (!permissionKey) {
    return true;
  }

  return Array.isArray(permissionKeys) && permissionKeys.includes(permissionKey);
}

export function hasAnyPermission(permissionKeys = [], permissionList = []) {
  if (!Array.isArray(permissionList) || permissionList.length === 0) {
    return true;
  }

  return permissionList.some((item) => hasPermission(permissionKeys, item));
}
